import {
  createSearchParams,
  Outlet,
  useNavigate,
  useParams,
  useSearchParams,
} from 'react-router-dom';
import { Breadcrumbs, CommonGrid, TopContainer } from '../layouts';
import { TopButtonArea, ActionFilters, GlobalFilter, SharePopup, BigButton } from '../common';
import _, { isEmpty, set } from 'lodash';
import { useScreenSettings } from '../helpers/configureHelper';
import constants, {
  COMMON_TAGS_MODEL_TYPES,
  MODEL_TYPES,
  MODULE_TYPES,
} from '../constants/constants';
import { getNewDesignPath, getParamsFromFilterBy, openCuratorRoom } from '../helpers/urlHelper';
import { getProjectTypeLabel, getFilterOptionsHelper } from '../helpers/dataHelper';
import { useRooms } from '../hooks/useRooms';
import { useFilterContext } from '../contexts/FilterContext';
import { usePageTitle } from '../hooks/usePageTitle';
import InfiniteScroll from '../components/InfiniteScroll/InfiniteScroll';
import { ThumbnailContainerV2 } from '../common/ThumbnailContainerV2';
import AddToCollectionPopup from '../common/AddToCollectionPopup';
import CollectionIcon from '../components/icons/CollectionIcon';
import { PageSearchBar } from '../common/UniversalSearchForm/UniversalSearchForm';
import PageTitle from '../common/PageTitle';
import { EditRoomPopup } from '../common/EditRoomPopup/EditRoomPopup';
import { paginatedRoomsActions } from '../redux/slicers/admin/paginatedRooms';
import { useDispatch } from 'react-redux';
import { addUpdateParamsInSequence } from '../redux/slicers/filters/filterSlicer';
import FilterSideModalButton from '../common/FilterSideModalButton';
import TopContainerV2 from '../layouts/TopContainerV2';
import FooterOptions from '../layouts/FooterOptions';
import { GlobalDefaultTeamMemberFilter, GlobalSearchTagsFilter } from '../common/GlobalFilter';
import { getLocalStorage, removeLocalStorage, totalItemCount, wait } from '../helpers/jsHelper';
import { useEffect, useMemo, useRef, useState } from 'react';
import { ROOM_TYPE } from '../constants/roomConstants';
import { IS_GAMIFIED_SKIP, START_ONBOARDING } from '../constants/projectConstants';
import { gamifyBoardingActions } from '../redux/slicers/gamifySlicer';
const { PROJECT_TYPE_OPTIONS } = constants;

export default function MyRooms({
  title,
  pageTitle,
  cardType = 'templates',
  apiConfig = {},
  breadcrumbs,
  useGlobalSearch,
  noDataText = 'No data found',
  cardProps,
  singleSelect,
  updatePageTitle = true,
  showFilterBy = true,
  modelType = MODEL_TYPES.TEMPLATES,
  hideSelectionCheckbox = false,
  children,
  designV2,
  hiddenTab,
  popupCardsSelected,
  is360Configurator,
  hideStickyHeader = null,
  skeletonContainerClass,
  redirect = true,
  showMenu = true,
  useGlobalFilter = true,
  subClassName = null,
  switchData = () => {},
  initialSelections = null,
  useRoomSortApi = false,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const filterCtx = useFilterContext();
  // const location = useLocation();
  const routeParams = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const [filterByForLightroom, setFilterByForLightroom] = useState(
    is360Configurator ? ROOM_TYPE.SILO : ''
  );
  const hasInitialized = useRef(false);
  const selectedDataInitialized = useRef(null);
  const [skipSort, setSkipSort] = useState(false);

  let roomType; // templates do not have room type while create new project/rooms does
  if (routeParams) {
    roomType = _.startCase(routeParams.id);
  }
  let project_type = _.find(PROJECT_TYPE_OPTIONS, (t) => {
    return t.label === roomType;
  });
  // const pathname = parseBasePathname(location);
  // cardType = cardType || _.replace(pathname, '/', '');

  let defaultFilterBy;
  const filterRoomType = searchParams.get('roomType');
  const curatorProp = searchParams.get('curatorProp');
  if (project_type) {
    defaultFilterBy = project_type;
  } else if (!isEmpty(filterRoomType)) {
    defaultFilterBy = {
      label: getProjectTypeLabel(filterRoomType),
      value: filterRoomType,
    };
  }

  // This will disable all action and remove action button on cards (currently used in configurator lighting)
  let disableRoomCardAction;
  if (!redirect && !showMenu) {
    disableRoomCardAction = true;
  }

  const pageSettings = useScreenSettings(cardType);
  const { sortOptions, defaultSortOption, showFavoriteIcon, showTeamMemberFilter, filterOptions } =
    pageSettings;

  const updatedFilterOptions = getFilterOptionsHelper(
    filterOptions,
    disableRoomCardAction,
    is360Configurator
  );

  const isRooms = cardType === 'rooms';
  title = title || (isRooms ? 'Select a room to start your new project' : _.startCase(cardType));
  const browserTabTitle = pageTitle || (isRooms ? 'My Rooms' : 'Templates');

  if (updatePageTitle) {
    usePageTitle(browserTabTitle);
  }

  let requestParams;
  if (disableRoomCardAction) {
    requestParams = useMemo(
      () => ({
        ...(filterByForLightroom === '-1'
          ? { is_custom: true }
          : { room_type: filterByForLightroom }),
        ...(apiConfig?.is_pdp_v2 ? { is_pdp_v2: apiConfig?.is_pdp_v2 } : {}),
        ...(apiConfig?.tags && skipSort ? { tags: apiConfig?.tags } : {}),
        skip_sort: skipSort,
      }),
      [is360Configurator, filterByForLightroom, apiConfig?.is_pdp_v2, apiConfig?.tags, skipSort]
    );
  }

  const { defaultCreatedBy, skipBrandFilter } = apiConfig;

  const {
    list,
    loading,
    fetchMoreData,
    hasMore,
    total,
    hasData,

    anySelected,
    allSelected,
    selected,
    selectedList,
    sortBy,
    filterBy,
    onSortChange,
    onFilterByChange,
    toggleAll,
    toggleItem,
    toggleSingleItem,
    addToCollection,
    resetSelection,
    search,
    onSearchChange,
  } = useRooms({
    filterByKey: 'room_type',
    defaultFilterBy,
    defaultBrands: apiConfig?.defaultBrands,
    defaultSort: defaultSortOption,
    useGlobalSearch,
    defaultCreatedBy,
    skipBrandFilter,
    useGlobalFilter,
    requestParams,
    useRoomSortApi,
  });

  // Restore selections when list is loaded and initialSelections are provided
  useEffect(async () => {
    if (hasInitialized.current || !initialSelections?.selected || !list?.length) {
      if (Object?.keys(initialSelections?.selected || {})?.length) {
        selectedDataInitialized.current = initialSelections?.selected;
      }
      return;
    }
    await wait(100);
    const selectedIds = Object?.keys(initialSelections?.selected || {})?.length
      ? initialSelections.selected
      : selectedDataInitialized?.current;
    if (selectedIds) {
      toggleItem(selectedIds, true);
      hasInitialized.current = true;
    }
  }, [list, initialSelections]);

  useEffect(() => {
    if (!list?.length && !search && !filterBy && !loading && !showMenu && !total) {
      switchData?.();
    }
  }, [loading]);

  const onEdit = (id) => {
    openCuratorRoom(id);
  };

  useEffect(() => {
    if (disableRoomCardAction) {
      popupCardsSelected({ anySelected, allSelected, selected, selectedList });
    }
  }, [disableRoomCardAction, selected]);

  useEffect(() => {
    if (is360Configurator) {
      handleFilterByChange({ label: 'Silo', value: '3' });
    }
  }, [is360Configurator]);

  useEffect(async () => {
    const isGamifiedSkip = getLocalStorage(IS_GAMIFIED_SKIP, true);
    if (isGamifiedSkip) {
      await wait(2000);
      removeLocalStorage(IS_GAMIFIED_SKIP);
      removeLocalStorage(START_ONBOARDING);
      dispatch(gamifyBoardingActions.openGamifiedDialog(true));
    }
  }, []);

  useEffect(() => {
    removeSort();
  }, [search, sortBy, filterBy]);

  const removeSort = () => {
    if (
      !useRoomSortApi ||
      search ||
      sortBy?.value !== defaultSortOption?.value ||
      filterBy?.value
    ) {
      setSkipSort(false);
    } else {
      setSkipSort(true);
    }
  };

  const handleFilterByChange = (option) => {
    if (roomType) {
      const roomType = option.value;
      let url = getNewDesignPath(roomType);
      if (roomType) {
        url = url + `?roomType=${roomType}&filterOrder=filterBy&filterBy=${roomType}`;
      }
      navigate(url.includes('undefined') ? url.replace('undefined', 'all') : url, {
        replace: true,
      });
    } else {
      // comment this code beacuse it's cuase issue in filter
      // setSearchParams(
      //   createSearchParams({
      //     roomType: option.value,
      //     ...(curatorProp && { curatorProp }),
      //   })
      // );
    }
    if (!disableRoomCardAction) {
      dispatch(addUpdateParamsInSequence({ filterBy: getParamsFromFilterBy(option, 'room_type') }));
    } else {
      setFilterByForLightroom(option.value);
    }
    onFilterByChange(option);
  };

  const handleRoomUpdate = (newData) => {
    dispatch(paginatedRoomsActions.update(newData));
  };

  const NoDataFound = () => {
    return (
      <div className="w-100 m-auto d-flex flex-column justify-content-center align-items-center">
        <h2>{noDataText}</h2>
        <p>Custom rooms developed by our in-house team on Imagine will be exclusively</p>
        <p>available to your organization and accessible here.</p>
      </div>
    );
  };

  return (
    <>
      {/* {breadcrumbs && !useGlobalSearch && <Breadcrumbs fullWidth list={breadcrumbs} />} */}
      {!useGlobalSearch && <Breadcrumbs fullWidth list={breadcrumbs} />}
      <CommonGrid
        noDataText={
          search ? `You don't have any ${cardType} with "${search}" name.` : NoDataFound()
        }
        sticky={hideStickyHeader ? false : true}
        className={(anySelected || allSelected) && designV2 ? 'show-action-footer' : ''}
        {...(designV2
          ? {
              topContainer: (
                <TopContainerV2
                  subClassName={
                    modelType === MODEL_TYPES.ROOM
                      ? `smaller-width myrooms-topContainerV2 ${subClassName} myProductSection`
                      : `smaller-width templates-topContainerV2 ${subClassName} myProductSection ${
                          disableRoomCardAction ? 'extraSmallCards' : ''
                        }`
                  }
                  hiddenTab={hiddenTab}
                  globalFilter={
                    !useGlobalSearch && (
                      <div>
                        <GlobalFilter designV2 />
                        <GlobalSearchTagsFilter designV2={designV2} />
                        <GlobalDefaultTeamMemberFilter designV2 />
                      </div>
                    )
                  }>
                  <>
                    {!useGlobalSearch && (
                      <>
                        {!disableRoomCardAction && (
                          <div className="totalCount">{totalItemCount(total)}</div>
                        )}
                        <PageSearchBar
                          designV2
                          model={COMMON_TAGS_MODEL_TYPES.ROOM}
                          onSearchChange={onSearchChange}
                          search={search}
                        />
                        {!disableRoomCardAction && (
                          <FilterSideModalButton showTeamMemberFilter={showTeamMemberFilter} />
                        )}
                        <ActionFilters
                          loading={loading}
                          sortProps={
                            // (loading || list?.length > 0) &&
                            {
                              disabled: Boolean(search),
                              value: sortBy,
                              data: sortOptions,
                              onChange: onSortChange,
                              containerClass: 'top-filter',
                            }
                          }
                          filterProps={
                            showFilterBy && {
                              // (loading || list?.length || filterBy) &&
                              value: filterBy,
                              data: updatedFilterOptions,
                              onChange: handleFilterByChange,
                              containerClass: 'top-filter',
                            }
                          }
                          showTeamMemberFilter={false}
                        />
                      </>
                    )}
                  </>
                </TopContainerV2>
              ),
            }
          : {
              topContainer: (
                <TopContainer
                  title={
                    !useGlobalSearch && <PageTitle title={title} total={total} search={search} />
                  }
                  item={cardType}
                  hasData={hasData}
                  buttonArea={
                    <div style={{ display: 'flex' }}>
                      {!useGlobalSearch && (
                        <TopButtonArea
                          hasData={hasData}
                          item={cardType}
                          topButtonList={
                            roomType
                              ? null
                              : [
                                  {
                                    element: BigButton,
                                    bigBtnClass: 'lf-btn-2',
                                    iconBefore: <CollectionIcon />,
                                    buttonTitle: 'Add To Collection',
                                    onClick: addToCollection,
                                  },
                                  {
                                    element: SharePopup,
                                    bigButton: true,
                                    bigBtnClass: 'lf-btn-2',
                                    selectedList,
                                    modelType: 3,
                                  },
                                ]
                          }
                          anySelected={anySelected}
                          selectedList={selectedList}
                        />
                      )}
                      {!useGlobalSearch && (
                        <FilterSideModalButton showTeamMemberFilter={showTeamMemberFilter} />
                      )}
                    </div>
                  }
                  searchBar={
                    !useGlobalSearch && (
                      <div className="mt-2">
                        <PageSearchBar
                          model={COMMON_TAGS_MODEL_TYPES.ROOM}
                          onSearchChange={onSearchChange}
                          search={search}
                        />
                      </div>
                    )
                  }
                />
              ),
            })}
        item={cardType}
        hasData={list.length > 0 || loading}
        list={list}
        {...(!designV2 &&
          !useGlobalSearch && {
            filterArea: (
              <>
                <ActionFilters
                  loading={loading}
                  sortProps={
                    // (loading || list?.length > 0) &&
                    {
                      value: sortBy,
                      data: sortOptions,
                      onChange: onSortChange,
                    }
                  }
                  filterProps={
                    showFilterBy && {
                      // (loading || list?.length || filterBy) &&
                      value: filterBy,
                      data: updatedFilterOptions,
                      onChange: handleFilterByChange,
                    }
                  }
                  selectedProps={
                    roomType
                      ? null
                      : {
                          allSelected: allSelected,
                          onSelectAll: () => toggleAll(),
                        }
                  }
                  showTeamMemberFilter={false}
                />
                <GlobalFilter />
              </>
            ),
          })}>
        <InfiniteScroll
          dataLength={list.length}
          skeletonContainerClass={skeletonContainerClass}
          next={fetchMoreData}
          hasMore={hasMore}
          loading={loading}
          hasChildren={hasData}
          scrollableTarget="infiniteScroll"
          showMenu={showMenu}
          redirect={redirect}>
          <ThumbnailContainerV2
            designV2={designV2}
            items={list}
            modelType={modelType}
            selected={selected}
            showMenu={showMenu}
            redirect={redirect}
            cardProps={{
              fullWidth: true,
              onSelect: !hideSelectionCheckbox && (singleSelect ? toggleSingleItem : toggleItem),
              resetSelection: resetSelection,
              curatorProp,
              ...cardProps,
            }}
          />
          {hasMore && !disableRoomCardAction && <div id="whiteShadow" />}
        </InfiniteScroll>

        {(anySelected || allSelected) && designV2 && !disableRoomCardAction && (
          <FooterOptions>
            <>
              <div className="selected-item">
                <ActionFilters
                  selectedProps={
                    list?.length > 0 && {
                      allSelected: allSelected,
                      onSelectAll: () => toggleAll(),
                    }
                  }
                />
                <span>{selectedList?.length || 0} Selected</span>
              </div>
              <div className="footer-action">
                <TopButtonArea
                  hasData={hasData}
                  item={cardType}
                  topButtonList={
                    roomType
                      ? null
                      : [
                          {
                            element: BigButton,
                            bigBtnClass: 'lf-btn-2',
                            iconBefore: <CollectionIcon />,
                            buttonTitle: 'Add To Collection',
                            onClick: addToCollection,
                          },
                          {
                            element: SharePopup,
                            bigButton: true,
                            bigBtnClass: 'lf-btn-2',
                            selectedList,
                            modelType: 3,
                          },
                        ]
                  }
                  anySelected={anySelected}
                  selectedList={selectedList}
                />
              </div>
            </>
          </FooterOptions>
        )}

        <EditRoomPopup onUpdateSuccess={handleRoomUpdate} />
      </CommonGrid>

      {!useGlobalSearch && <Outlet />}
      {children}

      <AddToCollectionPopup onSuccess={resetSelection} />
    </>
  );
}
